<template>
    <h4>BlueBased BV.</h4>
</template>

<script>
    export default {
        name: 'About_us'
    }
</script>